// Third Party
import * as React from 'react';

// Utils
import { useMobileSearchModal } from '@components/mobile-search-modal';
import { extractFirstPhraseBeforeComma } from '@utils/extract-first-phrase-before-comma';

// UI
import { Icon, IconNames } from '@components/icon';

type Props = { placeName?: string };

export const MobileSearchBar: React.FC<Props> = ({ placeName }) => {
  const { activateMobileSearchModal } = useMobileSearchModal();

  return (
    <div className="relative top-0 left-0 right-0 py-4 transition-colors duration-500 sm:hidden justify-center items-center text-center">
      <button
        onClick={activateMobileSearchModal}
        className="flex flex-row bg-white p-3 mx-auto rounded-full shadow-lg text-left space-x-2 w-full hover:cursor-pointer mt-1 border-[1.5px] border-primary-main"
        data-testid="@home/search-input-box-button"
      >
        <Icon
          name={IconNames.MAGNIFYING_GLASS}
          className="h-4 w-4 mt-1 sm:mt-0 text-primary-main"
        />
        <span
          className="text-md font-medium text-gray-main"
          data-testid="@home/search-input-box"
        >
          {placeName ? extractFirstPhraseBeforeComma(placeName) : 'Where to?'}
        </span>
      </button>
    </div>
  );
};
